import React from "react";
import ReactDOM from "react-dom/client";

import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles

import "./index.css";
import "./variables.css";
import "./theme.css";

import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

AOS.init();
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
